import axios from "axios";
import { url } from "../utils/api";
import { loadGuest } from "./auth";
import { getMyBooking } from "./booking";
import { CHECKOUT, GET_KEY, GET_PAYMENTS, LOAD_RECEIPTS, PAYMENT_ERROR } from './types';

// Get key
export const getKey = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/payments/getKey`, config);

        dispatch({
            type: GET_KEY,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: PAYMENT_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Checkout
export const checkout = (amount) => async dispatch => {
    try {
        const res = await axios.post(`${url}/api/payments/checkout`, {amount});
        dispatch(loadGuest());
        dispatch(getMyBooking());
        dispatch({
            type: CHECKOUT,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: PAYMENT_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}


// Get my receipts
export const getMyReceipts = (booking_id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/payments/receipts/${booking_id}`, config);

        dispatch({
            type: LOAD_RECEIPTS,
            payload: res.data
        });
        
    } catch (err) {
        dispatch({
            type: PAYMENT_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}

// Get All Receipts
export const getAllPayments = () => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    try {
        const res = await axios.get(`${url}/api/payments`, config);

        dispatch({
            type: GET_PAYMENTS,
            payload: res.data
        });
    } catch (err) {
        dispatch({
            type: PAYMENT_ERROR,
            payload: { msg: err.response.statusText, status: err.response.status}
        });
    }
}